module.exports = __webpack_public_path__ + "img/admin_adv_10.f3922ae7.png";